import React from 'react';
import CountWords from './CountWords';
import { Field } from 'src/components/RcForm';
import { get } from 'lodash';

const CountWordsWithFormItem = (props) => {
  const { keyName, maxCount } = props;
  return (
    <Field
      shouldUpdate={(p, c) => {
        const pV = get(p, keyName);
        const cV = get(c, keyName);
        return pV !== cV;
      }}>
      {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
        const word = getFieldValue(keyName);
        const count = (word || '').length;
        return <CountWords count={count} allCount={maxCount} />;
      }}
    </Field>
  );
};
export default CountWordsWithFormItem;
